import React from 'react';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import { MermaidDiagram } from '../../../../../../../../components/MermaidDiagram';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    overflowX: 'auto',
    width: '100%',
    margin: '16px 0',
    '& svg': {
      maxWidth: '100%',
      height: 'auto',
    },
  },
}));

type MermaidProps = {
  chart: string;
};

/**
 * Decorator-node renderer for a ```mermaid fence inside a Zori report document.
 * Wraps the shared themed MermaidDiagram with the centering/overflow layout used
 * for block diagrams in the report surface.
 */
export const Mermaid: React.FC<MermaidProps> = ({ chart }) => {
  const classes = useStyles();
  return (
    <div data-testid="mermaid-diagram">
      <MermaidDiagram chart={chart} className={classes.container} />
    </div>
  );
};
